export default "__VITE_ASSET__pSwgn15a__"